import React from 'react'
import { useNetworkingBrief } from '../NetworkingBriefProvider'
import {
  JsonItemProvider,
  JsonItemField,
  useJsonItem,
  JsonTextArea,
} from '../../../lib/json-editor'

export const EditorItemField = ({ ...props }) => {
  return <JsonItemField {...props} />
}

export const EditorItemTextField = ({ ...props }) => {
  return <JsonTextArea {...props} />
}

export const useEditorItem = useJsonItem

export const EditorItemProvider = ({ ...props }) => {
  const { networkingBriefDocument, setNetworkingBriefDocument } =
    useNetworkingBrief()

  return (
    <JsonItemProvider
      jsonDocument={networkingBriefDocument}
      setJsonDocument={setNetworkingBriefDocument}
      {...props}
    />
  )
}
